import { render, staticRenderFns } from "./TuitionManagement.vue?vue&type=template&id=e42cb320"
import script from "./TuitionManagement.vue?vue&type=script&lang=js"
export * from "./TuitionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports